import { render, staticRenderFns } from "./BeltsSelection.vue?vue&type=template&id=346b667c&scoped=true&"
import script from "./BeltsSelection.vue?vue&type=script&lang=js&"
export * from "./BeltsSelection.vue?vue&type=script&lang=js&"
import style0 from "./BeltsSelection.vue?vue&type=style&index=0&id=346b667c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b667c",
  null
  
)

export default component.exports